const ReactAppStage = process.env.REACT_APP_API_STAGE;
const appClient = process.env.REACT_APP_CLIENT_NAME;
// const appClient = 'maev'

const getApiLink = () => {
  
    if (ReactAppStage == "Live") {
      return "https://api.firstnestcare.co.uk/v1/";
    } else {
      return "https://firstnestcare.api.riolabz.com/v1/";
    }
};

const dev = {
  API_ENDPOINT_URL: getApiLink(),
};

const prod = {
  API_ENDPOINT_URL: getApiLink(),
};

const test = {
  API_ENDPOINT_URL: getApiLink(),
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
